import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { FileText, Download } from "lucide-react";
import { toast } from "sonner";
import PDFViewer from "@/components/PDFViewer";

export function LessonPdfViewer({ fileUrl, filename, colors }) {
  const [dataUrl, setDataUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setDataUrl(null);
    setError(false);
    axios.get(fileUrl, { responseType: "blob" }).then((res) => {
      const reader = new FileReader();
      reader.onloadend = () => { if (!cancelled) setDataUrl(reader.result); };
      reader.readAsDataURL(res.data);
    }).catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [fileUrl]);

  const handleDownload = () => {
    if (!dataUrl) return;
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    toast.success("PDF downloaded");
  };

  return (
    <div data-testid="lesson-pdf-viewer">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <FileText className="w-5 h-5" style={{ color: colors.accent }} />
          <h3 className="text-lg font-semibold" style={{ color: colors.text }}>Course Handout</h3>
        </div>
        <Button variant="outline" size="sm" onClick={handleDownload} disabled={!dataUrl} className="gap-2" data-testid="lesson-pdf-download">
          <Download className="w-4 h-4" />
          Download PDF
        </Button>
      </div>
      {error ? (
        <p className="text-sm text-red-500 p-4" data-testid="lesson-pdf-error">This handout could not be loaded.</p>
      ) : !dataUrl ? (
        <p className="text-sm p-4" style={{ color: colors.subtext }}>Loading handout...</p>
      ) : (
        <PDFViewer fileUrl={dataUrl} filename={filename} />
      )}
    </div>
  );
}
